import { TPeriod } from '@app/interfaces/waterbodyRegulation';

export const tableDataInit = {
  data: [
    {
      id: '1',
      minCatch: '100',
      maxCatch: '0',
      quantityLimit: 5,
      from: '2025-01-01',
      to: '2025-12-31',
      period: 'daily' as TPeriod,
      protected: false,
      forLicense: 'all',
      idfishtype: {
        id: 1,
        seasonal: true,
        quantity_weight: true,
        name_DE: 'Edelkrebs',
        name_FR: 'Ecrevisse à pattes rouges',
        name_IT: 'Gambero europeo ',
        name_EN: 'Galician Crayfish',
        name_scientific: 'Astacus astacus',
        code: 14500,
        isBreedable: true,
        ratioPerLiter: 666,
        abbreviation: '',
        softDeleted: false,
      },
      idfishtypesLinked: [
        {
          id: 2,
          seasonal: false,
          quantity_weight: false,
          name_DE: 'Galizierkrebs',
          name_FR: 'Ecrevisse à pattes grêles',
          name_IT: 'Gambero di Gallizia',
          name_EN: 'Noble crayfish',
          name_scientific: 'Astacus leptodactylus',
          code: 14501,
          isBreedable: null,
          ratioPerLiter: 777,
          abbreviation: null,
          softDeleted: false,
        },
      ],
      idwaterbody: {
        id: 27,
        nameDe: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameFr: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameEn: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameIt: '138 - Ual Val Vallesa/Ual Acla Mulin',
        longitude: 8.94214938,
        latitude: 46.68603242,
      },
      remarks: '',
      isBaseRegulation: true,
      softDeleted: false,
    },
    {
      id: '2',
      minCatch: '200',
      maxCatch: '0',
      quantityLimit: 2,
      from: '2025-01-01',
      to: '2025-12-31',
      period: 'daily' as TPeriod,
      protected: true,
      forLicense: 'all',
      idfishtype: {
        id: 2,
        seasonal: false,
        quantity_weight: false,
        name_DE: 'Galizierkrebs',
        name_FR: 'Ecrevisse à pattes grêles',
        name_IT: 'Gambero di Gallizia',
        name_EN: 'Noble crayfish',
        name_scientific: 'Astacus leptodactylus',
        code: 14501,
        isBreedable: null,
        ratioPerLiter: 777,
        abbreviation: null,
        softDeleted: false,
      },
      idfishtypesLinked: [],
      idwaterbody: {
        id: 27,
        nameDe: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameFr: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameEn: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameIt: '138 - Ual Val Vallesa/Ual Acla Mulin',
        longitude: 8.94214938,
        latitude: 46.68603242,
      },
      remarks: '',
      isBaseRegulation: true,
      softDeleted: false,
    },
    {
      id: '3',
      minCatch: '200',
      maxCatch: '0',
      quantityLimit: 2,
      from: '2025-01-01',
      to: '2025-12-31',
      period: 'daily' as TPeriod,
      protected: false,
      forLicense: 'all',
      idfishtype: {
        id: 3,
        seasonal: false,
        quantity_weight: true,
        name_DE: 'Dohlenkrebs',
        name_FR: 'Ecrevisse à pattes blanches',
        name_IT: 'Gambero di fiume',
        name_EN: 'White-clawed crayfish',
        name_scientific: 'Austropotamobius pallipes',
        code: 14502,
        isBreedable: null,
        ratioPerLiter: null,
        abbreviation: null,
        softDeleted: false,
      },

      idfishtypesLinked: [],
      idwaterbody: {
        id: 27,
        nameDe: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameFr: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameEn: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameIt: '138 - Ual Val Vallesa/Ual Acla Mulin',
        longitude: 8.94214938,
        latitude: 46.68603242,
      },
      remarks: '',
      isBaseRegulation: false,
      softDeleted: false,
    },
  ],
  filterOptions: {
    uniqueWaterbodies: [
      {
        id: 22,
        nameDe: '131 - Ual Acletta inkl. Zuflüsse',
        nameFr: '131 - Ual Acletta inkl. Zuflüsse',
        nameEn: '131 - Ual Acletta inkl. Zuflüsse',
        nameIt: '131 - Ual Acletta compresi gli affluenti',
        longitude: 8.84091773,
        latitude: 46.70528441,
      },
      {
        id: 25,
        nameDe: '136 - Rein da Sumvitg: Quelle - Lag da Runcahez, inkl. Zuflüsse',
        nameFr: '136 - Rein da Sumvitg: Quelle - Lag da Runcahez, inkl. Zuflüsse',
        nameEn: '136 - Rein da Sumvitg: Quelle - Lag da Runcahez, inkl. Zuflüsse',
        nameIt: '136 - Rein da Sumvitg: sorgente - Lag da Runcahez, compresi gli affluenti',
        longitude: 8.98042644,
        latitude: 46.66517364,
      },
      {
        id: 27,
        nameDe: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameFr: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameEn: '138 - Ual Val Vallesa/Ual Acla Mulin',
        nameIt: '138 - Ual Val Vallesa/Ual Acla Mulin',
        longitude: 8.94214938,
        latitude: 46.68603242,
      },
    ],
    uniqueFishTypes: [
      {
        id: 1,
        seasonal: true,
        quantity_weight: true,
        name_DE: 'Edelkrebs',
        name_FR: 'Ecrevisse à pattes rouges',
        name_IT: 'Gambero europeo ',
        name_EN: 'Galician Crayfish',
        name_scientific: 'Astacus astacus',
        code: 14500,
        isBreedable: true,
        ratioPerLiter: 666,
        abbreviation: '',
        softDeleted: false,
      },
      {
        id: 2,
        seasonal: false,
        quantity_weight: false,
        name_DE: 'Galizierkrebs',
        name_FR: 'Ecrevisse à pattes grêles',
        name_IT: 'Gambero di Gallizia',
        name_EN: 'Noble crayfish',
        name_scientific: 'Astacus leptodactylus',
        code: 14501,
        isBreedable: null,
        ratioPerLiter: 777,
        abbreviation: null,
        softDeleted: false,
      },
      {
        id: 3,
        seasonal: false,
        quantity_weight: true,
        name_DE: 'Dohlenkrebs',
        name_FR: 'Ecrevisse à pattes blanches',
        name_IT: 'Gambero di fiume',
        name_EN: 'White-clawed crayfish',
        name_scientific: 'Austropotamobius pallipes',
        code: 14502,
        isBreedable: null,
        ratioPerLiter: null,
        abbreviation: null,
        softDeleted: false,
      },
    ],
  },
  loading: false,
  error: false,
};
